import { useTranslation } from '../../../i18n/useTranslation';
import styles from './order-confirmatio-success.module.scss';

const OrderConfirmationSuccess: React.FC = () => {
    const { t } = useTranslation('translation');

    return (
        <>
            <div className={styles.container}>
                <div className={styles.row}>
                    <label className={styles.h1}>{t('FIXCENTER_ORDERING.MESSAGE_3')}</label>
                </div>
                <div className={styles.row}>
                    <label className={styles.h2}>{t('FIXCENTER_ORDERING.MESSAGE_4')}!</label>
                </div>
            </div>
        </>
    );
};

export default OrderConfirmationSuccess;
